export enum AwardStatus {
  Offered = 'Offered',
  Accepted = 'Accepted',
  Awarded = 'Awarded',
  Declined = 'Declined',
  Unresponsive = 'Unresponsive'
}

const LABEL_ALIASES: Record<string, AwardStatus> = {
  'award offered': AwardStatus.Offered,
  'award accepted': AwardStatus.Accepted,
  'award declined': AwardStatus.Declined,
  'award cancelled': AwardStatus.Unresponsive
};

export function toAwardStatus(value: string | null | undefined): AwardStatus | null {
  const normalized = (value ?? '').trim().toLowerCase();
  if (!normalized) return null;
  return (
    LABEL_ALIASES[normalized] ??
    Object.values(AwardStatus).find((status) => status.toLowerCase() === normalized) ??
    null
  );
}

export function isAwardStatus(value: string | null | undefined, ...statuses: AwardStatus[]): boolean {
  const status = toAwardStatus(value);
  return status !== null && statuses.includes(status);
}
